var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: _vm.disableTransitions ? "" : "el-zoom-in-center" } },
    [
      _c(
        "span",
        {
          staticClass: "vue-tag",
          class: [
            _vm.type ? "vue-tag_" + _vm.type : "",
            _vm.tagSize && "vue-tag_" + _vm.tagSize,
            { "is-hit": _vm.hit },
          ],
          style: { backgroundColor: _vm.color },
        },
        [
          _vm.icon
            ? _c("i", { staticClass: "vue-tag__icon", class: _vm.icon })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm.closable
            ? _c("i", {
                staticClass: "vue-tag__close fa fa-times",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleClose.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }